import {
  BUZZER_BRIDGE_CALL_STATUS,
  BUZZER_BRIDGE_REGISTRATION_STATUS,
} from 'dashboard/services/BuzzerBridgeSipClient';

export const SET_REGISTRATION_STATUS = 'SET_REGISTRATION_STATUS';
export const SET_CALL_STATUS = 'SET_CALL_STATUS';
export const SET_REMOTE_AUDIO_BLOCKED = 'SET_REMOTE_AUDIO_BLOCKED';

export const state = {
  registrationStatus: BUZZER_BRIDGE_REGISTRATION_STATUS.UNREGISTERED,
  registrationError: null,
  callStatus: BUZZER_BRIDGE_CALL_STATUS.IDLE,
  callDirection: null,
  disconnectReason: null,
  remoteAudioBlocked: false,
};

export const mutations = {
  [SET_REGISTRATION_STATUS]($state, { status, error = null }) {
    $state.registrationStatus = status;
    $state.registrationError = error;
  },
  [SET_CALL_STATUS]($state, { status, direction = null, reason = null }) {
    $state.callStatus = status;
    $state.callDirection = direction;
    $state.disconnectReason = reason;
  },
  [SET_REMOTE_AUDIO_BLOCKED]($state, isBlocked) {
    $state.remoteAudioBlocked = isBlocked;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
